<template>
  <div class="report-warp">
    <div class="header">
      <div class="scale-name">{{ studentInfo.ScaleName }}</div>
      <div class="content">
        <div class="create-time">
          测评时间:
          {{ $LYCom.getTime(studentInfo.MMPTTime, "YYYY-MM-DD HH:mm:ss") }}
        </div>
        <!-- <div class="user-name">测评人:{{ studentInfo.StudentName }}</div> -->
      </div>
    </div>
    <div class="main">
      <div class="title">
        <i class="icon el-icon-user-solid"></i>
        个人信息
      </div>
      <div class="student-info flex bg">
        <div><span>姓名：</span>{{ studentInfo.StudentName }}</div>
        <div class="item"><span>身份证号：</span>{{ studentInfo.IDCard }}</div>
        <div><span>性别：</span>{{ studentInfo.SexName }}</div>
        <div><span>年龄：</span>{{ studentInfo.Age }}岁</div>
        <div class="item" v-if="studentInfo.SchoolName">
          <span v-if="schoolPersonType&&schoolPersonType=='teacher'"> 单位：</span>
          <span v-else> 学校：</span>
          {{ studentInfo.SchoolName }}
        </div>
        <div  v-if="studentInfo.ClassName">
          <span>班级：</span>{{ studentInfo.ClassName }}
        </div>
      </div>
      <div class="title">
        <i class="icon el-icon-info"></i>
        量表介绍
      </div>
      <div class="introduce bg">
        <div class="scale">{{ studentInfo.ScaleName }}</div>
        <div class="content">
          {{ studentInfo.instruction }}
        </div>
      </div>

      <div class="title">
        <i class="icon el-icon-s-data"></i>
        因子图表
      </div>
      <el-row v-if="dataArr.length <= 2" style="min-height: 350px">
        <el-col
          v-for="item in dataArr"
          :span="24 / dataArr.length"
          :key="item.id"
        >
          <div
            class="canvas-warp"
            :id="item.id"
            :style="'width:100%;height:350px'"
          ></div>
        </el-col>
      </el-row>
      <div v-else class="canvas_warp" style="display: flex; flex-wrap: wrap">
        <div
          v-for="(item, index) in dataArr"
          :key="index"
          :id="item.id"
          :style="'width:50%;height:350px;'"
        ></div>
      </div>
      <div class="title">
        <i class="icon el-icon-s-claim"></i>
        因子得分
      </div>
      <table class="tab-score">
        <tr>
          <th>名字</th>
          <th>编码</th>
          <th>包含题目</th>
          <th>因子得分</th>
          <th>程度</th>
        </tr>

        <tr v-for="(item, index) in studentInfo.MMPTResultList" :key="index">
          <td>{{ item.rule_name }}</td>
          <td>{{ numberArr[index] }}</td>
          <td>{{ item.question_num }}</td>
          <td>{{ item.score }}</td>
          <td>
            {{ item.severity_description ? item.severity_description : "-" }}
          </td>
        </tr>
      </table>
      <div class="title">
        <i class="icon el-icon-s-order"></i>
        测评结果
      </div>
      <div class="conclusion-warp">
        <div
          class="conclusion-item bg"
          v-for="(item, index) in studentInfo.MMPTResultList"
          :key="index"
        >
          <div class="conclusion-name">
            <i class="icon el-icon-document"></i>
            {{ item.rule_name }} <span>({{ item.score }})</span>
          </div>
          <div class="content">
            <span
              class="description"
              v-if="item.severity_description"
              :style="{
                background: $LYCom.GetMMPTDegreeColor(
                  item.severity,
                  item.severity_description
                ),
              }"
            >
              {{ item.severity_description }}
            </span>
            <div v-if="item.analyzes">
              {{ item.analyzes }}
            </div>
            <div v-if="item.conclusion">
              <span>测评结论:</span>{{ item.conclusion }}
            </div>
            <div v-if="item.suggestion">
              <span>指导建议:</span> {{ item.suggestion }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from "echarts";
import westeros from "@/components/ECharts/theme/westeros";

export default {
  props: {
    admScaleID: {
      type: Number,
      default: 0,
    },
    schoolPersonType: {
      type: String,
      default: null,
    },
    isDetaled: {
      type: Boolean,
      default: false,
    },
    mmpt_record_id: {
      default: 0,
    },
  },
  data() {
    return {
      dataArr: [],
      numberArr: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
      ],
      chart: null,
      studentInfo: {},
    };
  },
  mounted() {
    this.getRepordivata();
  },
  methods: {
    getRepordivata() {
      // 获取量表配置数据
      console.log(this)
      let self = this;
      self.PostUrl = "MMPTBiz.GetMMPTReportById";
      /* 判断校内校外查看报告接口 */
      if (self.schoolPersonType && self.schoolPersonType == "outsiderPerson") {
        self.PostUrl = "MMPTBiz.GetMMPTReportById2";
      }
      // 教师测评查看报告
      else if (self.schoolPersonType && self.schoolPersonType == "teacher") {
        self.PostUrl = "MMPTBiz.GetMMPTReportById3";
      }

      LYCom.AsynCallBiz(
        (e) => {
          if (e.err) {
            self.$message.error("获取数据错误，" + e.err);
          } else {
            if (e.rtnObj) {
              // 保存请求结果
              var tempdata = e.rtnObj;
              // 量表标题
              self.ScaleName = tempdata.ScaleName;
              // 学生信息
              self.studentInfo = e.rtnObj;
              self.studentInfo.MMPTResultList =
                self.studentInfo.MMPTResultList.filter(
                  (item) => item.conclusion
                ); //过滤掉没有结论的
              // let resultList = tempdata.MMPTResultList; // 建议/结论

              let configList = tempdata.ChartConfigList; // 图形配置数据

              // let specialData; // 自定义建议
              // if (resultList && resultList.length > 0) {
              //   for (let i = 0; i < resultList.length; i++) {
              //     let item = resultList[i];
              //     if (
              //       item &&
              //       item.suggestion != "" &&
              //       item.suggestion != null &&
              //       self.SugList.indexOf(item.suggestion) === -1
              //     ) {
              //       self.SugList.push(item.suggestion);
              //     }
              //   }

              //   let conclusionArr = [],
              //     sugArr = [];
              //   resultList.forEach((resItem) => {
              //     // 整合结论
              //     if (
              //       resItem &&
              //       resItem.conclusion &&
              //       conclusionArr.indexOf(resItem.conclusion) == -1
              //     ) {
              //       conclusionArr.push(resItem.conclusion);
              //     }
              //     // 整合建议
              //     if (
              //       resItem &&
              //       resItem.suggestion &&
              //       sugArr.indexOf(resItem.suggestion) == -1
              //     ) {
              //       sugArr.push(resItem.suggestion);
              //     }
              //   });
              //   self.SugList = sugArr;
              //   self.ConclusionList = conclusionArr;
              // }
              // // 自定义建议
              // if (configList && configList.length > 0) {
              //   specialData = configList.filter((m) => m.chart_type == 6);
              // }
              // if (specialData && specialData.length > 0) {
              //   specialData.forEach((w) => {
              //     self.ConclusionList.push("总分:" + w.items[0].score + "分");
              //   });
              // }
              // 组织图形配置
              if (configList && configList.length > 0) {
                console.log(configList);
                var index = 0;
                configList.forEach((item) => {
                  if (item.items && item.items.length > 0) {
                    var result = {};
                    switch (item.chart_type) {
                      case 1:
                        result = self.convertbarData(item, index, tempdata);
                        break;
                      case 2:
                        result = self.convertgaugeData(item, index, tempdata);
                        break;

                      case 3:
                        result = self.convertradarData(item, index, tempdata);
                        break;
                      case 4:
                        result = self.convertSeeSawData(item, index, tempdata);
                        break;
                      case 5:
                        result = self.convertPieData(item, index, tempdata);
                        break;
                      case 6:
                        result = self.convertRainbowData(item, index, tempdata);
                        break;
                      case 7:
                        result = self.convertlineData(item, index, tempdata);
                        break;
                      case 8:
                        result = self.convertScatter(item, index, tempdata);
                        break;
                      case 10:
                        result = self.convertbarData2(item, index, tempdata);
                        break;
                    }
                    index++;
                    self.dataArr.push(result);
                    console.log(self.dataArr);
                    self.$nextTick(() => {
                      setTimeout(() => {
                        //  执行echarts方法
                        self.initChart(result);
                      }, 100);
                    });
                  }
                });
              }
            } else {
              self.taskList = [];
              self.opt = true;
            }
          }
        },
       // "MMPTBiz.GetMMPTReportById",
         self.PostUrl,
        LYCom.GetToken(),
        self.mmpt_record_id
      );
    },
    // 象限图(艾森克人格问卷
    convertScatter(data, index, tempdata, type) {
      var RangeDescribe = JSON.parse(data.range_description);
      let arr = data.items;
      let markLine = RangeDescribe.series.markLine;
      let xName = RangeDescribe.series.extraconfig.X;
      let yName = RangeDescribe.series.extraconfig.Y;

      let xMin = 0;
      let xMax = 100; // 初始化100
      let yMin = 0;
      let yMax = 100;
      let coordinates = []; //圆点位置
      let markAreaArr = RangeDescribe.series.markArea.data; // 四个象限名字和位置
      let markAreaData = []; //马氏线配置项
      //   组装象限名字和坐标
      if (markAreaArr && markAreaArr.length > 0) {
        markAreaArr.forEach((item) => {
          let markAreaDataInner = [];
          let markAreaObj = {
            name: item[0].name,
            coord: item[0].coord,
          };
          let obj = {
            coord: item[0].coord,
          };
          markAreaDataInner.push(markAreaObj);
          markAreaDataInner.push(obj);
          markAreaData.push(markAreaDataInner);
        });
      }
      //   圆点坐标
      if (arr && arr.length > 0) {
        arr.forEach((item) => {
          if (item.CaculationName == xName) {
            xMin = item.Min;
            xMax = item.Max;
          }
          if (item.CaculationName == yName) {
            yMin = item.Min;
            yMax = item.Max;
          }
          coordinates.push(item.score);
        });
      }
      let o_data = [
        {
          type: "scatter",
          data: [coordinates],
          symbolSize: 10,
          markLine: markLine,
          markArea: {
            silent: true,
            data: markAreaData,
          },
        },
      ];
      let id = (this.isDetaled ? "dp" : "kp") + index;
      let oDem = document.getElementById(id);
      let options = {
        id: (this.isDetaled ? "dp" : "kp") + index,
        itemType: type,
        title: {
          text: RangeDescribe.option.title.text,
          textStyle: {
            fontSize: 12,
          },
          bottom: 30,
          left: 370, // n量表
        },
        tooltip: {
          trigger: "item",
          axisPointer: {
            show: true,
            type: "cross",
            lineStyle: {
              type: "dashed",
              width: 1,
            },
          },
        },
        grid: {
          top: "20px",
          right: "10px",
          left: "30px",
          bottom: "20px",
          show: true,
          borderColor: "#333",
          backgroundColor: "#ffffff",
        },
        xAxis: {
          name: RangeDescribe.xAxis.name,
          type: "value",
          scale: true,
          max: xMax,
          min: xMin,
          offset: 0,
          splitLine: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: "#000",
              fontWeight: 600,
            },
          },
          axisTick: {
            inside: true,
          },
          nameTextStyle: {
            verticalAlign: "bottom",
            padding: [0, 0, 0, -80],
            fontSize: 12,
          },
        },
        yAxis: {
          name: "",
          type: "value",
          scale: true,
          max: yMax,
          offset: 0,
          min: yMin,
          axisTick: {
            inside: false,
          },
          splitLine: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: "#666",
            },
          },
        },
        series: o_data,
      };
      return options;
    },
    /* 柱状图 */
    convertbarData(data, index, tempdata) {
      var dataAxis = [];
      var tempData = [];
      var max = 0,
        min = 0;
      data.items.forEach((item) => {
        dataAxis.push(item.rule_name);
        tempData.push(item.score);
        if (max < item.max) {
          max = item.max;
        }
        if (min > item.min) {
          min = item.min;
        }
      });
      let markLine = {};
      var barcolor = "";
      let Fn = "";
      // 判断是否有额外配置参数
      if (data.range_description) {
        var RangeDescribe = JSON.parse(data.range_description);
        markLine = RangeDescribe.markLine;
        if (RangeDescribe.color) barcolor = RangeDescribe.color;
        if (
          RangeDescribe.itemStyle &&
          RangeDescribe.itemStyle.normal &&
          RangeDescribe.itemStyle.normal.color
        ) {
          Fn = RangeDescribe.itemStyle.normal.color;
        }
      }
      let options = {
        id: (this.isDetaled ? "dp" : "kp") + index,
        xAxis: {
          data: dataAxis,
          axisLabel: {
            inside: false,
            interval: 0,
            rotate: 30,
            textStyle: {
              color: "#a0a0f0",
            },
          },
          z: 10,
        },

        yAxis: {
          type: "value",
          max: max,
          min: min,
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              color: "#777",
            },
          },
        },
        dataZoom: [
          {
            type: "inside",
          },
        ],
        series: [],
      };

      options.series.push({
        type: "bar",
        name: data.title,
        label: {
          show: true,
        },
        itemStyle: {
          normal: {
            color: function (params) {
              let getColor = eval(Fn);
              return getColor;
            },
          },
        },
        color: barcolor,
        data: tempData,
        markLine: markLine,
      });
      return options;
    },
    // 折线图
    convertlineData(data, index, tempdata) {
      var dataAxis = [];
      var markline = "";
      var tempData = [];
      var yAxisConfig = {
        max: 0,
        min: 0,
        type: "value",
        data: [],
      };
      var max = 0,
        min = 0;
      if (data.range_description) {
        var RangeDescribe = JSON.parse(data.range_description);

        if (RangeDescribe.series) {
          markline = RangeDescribe.series.markLine;
        }
        if (RangeDescribe.min) {
          min = RangeDescribe.min;
        }
        if (RangeDescribe.max) {
          max = RangeDescribe.max;
        }

        //设置max min 在轮询设置max之后,再绑定max的值
        if (RangeDescribe.yAxis) {
          if (RangeDescribe.yAxis.max != 0) {
            max = RangeDescribe.yAxis.max;
          }
          if (RangeDescribe.yAxis.min != 0) {
            min = RangeDescribe.yAxis.min;
          }
          if (RangeDescribe.yAxis.type) {
            if (RangeDescribe.yAxis.type == "category") {
              yAxisConfig.type = RangeDescribe.yAxis.type;
              yAxisConfig.data = dataAxis;
              dataAxis = null;
            }
          }
        }
      }
      data.items.forEach((item) => {
        dataAxis.push(item.rule_name);
        tempData.push(item.score);
        if (max < item.max) {
          max = item.max;
        }
        if (min > item.min) {
          min = item.min;
        }
      });
      let options = {
        id: (this.isDetaled ? "dp" : "kp") + index,
        grid: {
          top: 20,
          left: 50, //调整y轴与左侧的距离，显示更多文字
          bottom: 80,
          right: 50,
        },
        xAxis: {
          data: dataAxis,
          axisLabel: {
            inside: false,
            interval: 0,
            rotate: 30,
            textStyle: {
              color: "#a0a0f0",
              fontSize: 16,
            },
            max: max,
            min: min,
          },
          z: 10,
          splitLine: {
            show: true,
            lineStyle: {
              color: "#d5c9c9",
            },
          },
          // splitLine:{
          //   show:false  去除虚线
          // }
        },
        yAxis: {
          type: yAxisConfig.type,
          data: yAxisConfig.data,
          max: max,
          min: min,
          axisLine: {
            show: false,
          },
          axisTick: {
            interval: 0,
            show: false,
          },
          axisLabel: {
            interval: 0,
            textStyle: {
              color: "#777",
              fontSize: 16,
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "#d5c9c9",
            },
          },
        },
        dataZoom: [
          {
            type: "inside",
          },
        ],
        series: [],
      };
      options.series.push({
        type: "line",
        name: data.title,
        label: {
          show: true,
        },
        data: tempData,
        markLine: markline,
      });

      return options;
    },
    // 柱状图 自定义量表 中学生心理健康测评
    convertbarData2(data, index, tempdata) {
      let labelData = [];
      let standardMax = [];
      let seriesData = [];
      if (
        tempdata &&
        tempdata.MMPTResultList &&
        tempdata.MMPTResultList.length
      ) {
        tempdata.MMPTResultList.forEach((item) => {
          if (item.conclusion) {
            labelData.push(item.rule_name);
            standardMax.push(item.standardMax);
            seriesData.push({
              value: item.score,
              label: {
                show: true,
                position: "top",
                fontSize: 16,
                formatter: function (a) {
                  return `${a.value}分`;
                },
              },
              itemStyle: {
                color: item.score > item.standardMax ? "#c0392b" : "#aceb67",
              },
            });
          }
        });
      }
      let option = {
        // color: ["#9393dd", "#c0392b", "#aceb67"],
        id: (this.isDetaled ? "dp" : "kp") + index,
        tooltip: {},
        grid: {
          // top: 70,
          top: 50,
          // left: 20, //调整y轴与左侧的距离，显示更多文字
          left: 30, //调整y轴与左侧的距离，显示更多文字
          // bottom: 50,
          bottom: 70,
          right: 20,
        },
        xAxis: [
          {
            type: "category",
            axisLabel: {
              // interval: "auto",
              textStyle: {
                color: "#777",
                fontSize: 16,
              },
              interval: 0, 
              rotate: 30
            },
            data: labelData,
            axisTick: {
              show: false,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "分",
            axisLabel: {
              interval: "auto",
              textStyle: {
                color: "#777",
                fontSize: 16,
              },
            },
          },
        ],
        legend: {
          data: ["标准分", "得分(正常)", "得分(异常)"],
          top: 20,
          right: 20,
        },
        series: [
          {
            name: "得分(正常)",
            show: false,
            data: [],
            type: "bar",
            width: 0,
            color: "#aceb67",
          },
          {
            name: "标准分",
            label: {
              show: true,
              position: "top",
              fontSize: 16,
              formatter: function (a) {
                return `${a.value}分`;
              },
            },
            data: standardMax,
            type: "bar",
            color: "#0b57d0",
          },
          {
            name: "得分",
            data: seriesData,
            type: "bar",
          },

          {
            name: "得分(异常)",
            show: false,
            data: [],
            type: "bar",
            width: 0,
            color: "#c0392b",
          },
        ],
      };
      return option;
    },
    // 仪表盘
    convertgaugeData(data, index, tempdata) {
      var between = JSON.parse(data.range_description);
      var max = 0,
        min = 0;
      var detail = {};
      if (between) {
        if (between.color && between.color.length > 0) {
          between.color.forEach((item) => {
            if (item.max >= max) {
              max = item.max;
            }
            if (item.min <= min) {
              min = item.min;
            }
          });
        }
        if (between.detail) {
          detail = between.detail;
        }
      }
      let options = {
        id: (this.isDetaled ? "dp" : "kp") + index,
        tooltip: {
          formatter: "{a} <br/>{b} : {c}分",
        },
        title: {
          text: tempdata.ChartConfigList[index].title,
          bottom: "15%",
          left: "center",
        },
        series: [],
      };
      var tempData = [];
      data.items.forEach((item1) => {
        tempData.push({
          value: item1.score,
          name: "总分",
        });
      });

      var colorArea = this.getColorArea(data.range_description);
      options.series.push({
        type: "gauge",
        name: data.Title,
        axisLine: {
          lineStyle: {
            color: colorArea,
          },
        },
        detail: detail,
        min: min,
        max: max,
        data: tempData,
      });
      return options;
    },
    // 跷跷板图形
    convertSeeSawData(data, index, tempdata) {
      var datascore = data.items.filter((m) => m.rule_name != "总分");
      var factor = {
        left: datascore[0],
        right: datascore[1],
      };
      var point = {
        left: 1650,
        right: 1650,
      };
      var Bracket = {
        left: 550,
        right: 550,
      };
      if (factor.left.score > factor.right.score) {
        point.left = point.left - 1100;
        point.right = point.right + 1100;
        Bracket.left = Bracket.left - 550;
        Bracket.right = Bracket.right + 550;
      } else if (factor.left.score < factor.right.score) {
        point.right = point.right - 1100;
        point.left = point.left + 1100;
        Bracket.left = Bracket.left + 550;
        Bracket.right = Bracket.right - 550;
      }
      var markLineOpt = {
        animation: true,
        lineStyle: {
          type: "solid",
          width: 5,
        },

        data: [
          [
            {
              coord: [0, Bracket.left],
              symbol: "none",
            },
            {
              coord: [1100, Bracket.right],
              symbol: "none",
            },
          ],
        ],
      };

      var options = {
        id: (this.isDetaled ? "dp" : "kp") + index,
        title: {
          text: tempdata.ScaleName,
          textStyle: {
            fontSize: 14,
            fontWeight: 500,
          },
        },
        legend: {
          emphasis: {
            rich: {
              b: {
                height: 40,
              },
            },
          },
        },
        tooltip: {
          //formatter: " {a}:<br />" + "分数: ({c})"
          formatter: function (a, b) {
            return a.seriesName + ":<br />" + "分数:" + a.data.score;
          },
        },
        xAxis: [
          {
            gridIndex: 0,
            min: 0,
            max: 1800,
            show: false,
          },
        ],
        yAxis: [
          {
            gridIndex: 0,
            min: 0,
            max: 1800,
            show: false,
          },
        ],
        series: [
          {
            name: "跷跷板",
            type: "scatter",
            xAxisIndex: 0,
            yAxisIndex: 0,
            markLine: markLineOpt,
          },
          {
            name: "支架",
            type: "pictorialBar",
            symbolSize: ["40", "40"],

            symbol: "triangle",
            itemStyle: {
              emphasis: {
                opacity: 1,
              },
            },
            data: [
              {
                value: [
                  (point.left + point.right) / 6,
                  ((point.left + point.right) / 6) * 2,
                ],
                symbolPosition: "center",
                score: "",
              },
            ],
            z: 12,
          },
          {
            name: factor.left.rule_name,
            type: "pictorialBar",
            symbolSize: ["80", "80"],
            itemStyle: {
              color: {
                type: "radial",
                x: 0.5,
                y: 0.5,
                r: 0.5,
                colorStops: [
                  {
                    offset: 0,
                    color: "#B452CD", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#FFD700", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
            symbol: "circle",

            data: [
              {
                value: [0, point.left],
                symbolPosition: "center",
                score: factor.left.score,
              },
            ],
            z: 12,
          },
          {
            name: factor.right.rule_name,
            type: "pictorialBar",
            symbolSize: ["80", "80"],
            itemStyle: {
              color: {
                type: "radial",
                x: 0.5,
                y: 0.5,
                r: 0.5,
                colorStops: [
                  {
                    offset: 0,
                    color: "#B452CD", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#87CEFA", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
            symbol: "circle",

            data: [
              {
                value: [1100, point.right],
                symbolPosition: "center",
                score: factor.right.score,
              },
            ],
            z: 12,
          },
        ],
      };
      return options;
    },
    // 饼状图（暂无对应量表）
    convertPieData(data, index, tempdata) {},
    // 雷达图
    convertradarData(data, index, tempdata) {
      let options = {
        id: (this.isDetaled ? "dp" : "kp") + index,
        title: {
          text: tempdata.ScaleName,
          textStyle: {
            fontSize: 14,
            fontWeight: 500,
          },
          subtext: data.title,
        },
        tooltip: {},
        series: [],
      };
      var tempData = [];
      var indicator = [];
      data.items.forEach((item1) => {
        var max = 0,
          min = 0;
        if (max < item1.max) {
          max = item1.max;
        }
        if (min > item1.min) {
          min = item1.min;
        }
        indicator.push({
          min: min,
          max: max,
          name: item1.rule_name,
        });
        tempData.push(item1.score);
      });
      options.radar = {
        indicator: indicator,
        name: {
          textStyle: {
            color: "#fff",
            backgroundColor: "#777",
            borderRadius: 3,
            padding: [3, 5],
          },
        },
      };
      options.series.push({
        type: "radar",
        name: tempdata.ScaleName,
        label: {
          show: true,
          position: "insideBottom",
        },
        data: [
          {
            value: tempData,
            name: data.title,
            label: {
              show: true,
              position: "insideBottom",
            },
          },
        ],
      });
      return options;
    },
    // 彩虹图   （幸福感指数)
    convertRainbowData(data, index, tempdata) {
      var max = 0,
        min = 0,
        score = 0;
      var dataAxis = [];
      var tempData = [];
      var totalScore = 0;
      data.items.forEach((item) => {
        dataAxis.push(item.rule_name);
        tempData.push(item.score);
        score = Math.round(item.score);
        totalScore = item.score;
        if (max < item.max) {
          max = item.max;
        }
        if (min > item.min) {
          min = item.min;
        }
      });
      var average = max / 7;
      let options = {
        id: (this.isDetaled ? "dp" : "kp") + index,
        title: {
          text: tempdata.ScaleName + "(总分：" + totalScore + "分)",
          textStyle: {
            fontSize: 14,
            fontWeight: 500,
          },
        },
        visualMap: {
          top: 20,
          left: 2,
          pieces: [
            {
              gt: min,
              lte: average * 1,
              label: "紫【" + min + "-" + average * 1 + "分】",
              color: "#8B00FF",
            },
            {
              gt: average * 1,
              lte: average * 2,
              label: "蓝【" + average + "-" + average * 2 + "分】",
              color: "#0000FF",
            },
            {
              gt: average * 2,
              lte: average * 3,
              label: "青【" + average * 2 + "-" + average * 3 + "分】",
              color: "#00FFFF",
            },
            {
              gt: average * 3,
              lte: average * 4,
              label: "绿【" + average * 3 + "-" + average * 4 + "分】",
              color: "#00FF00",
            },
            {
              gt: average * 4,
              lte: average * 5,
              label: "黄【" + average * 4 + "-" + average * 5 + "分】",
              color: "#FFFF00",
            },
            {
              gt: average * 5,
              lte: average * 6,
              label: "橙【" + average * 5 + "-" + average * 6 + "分】",
              color: "#FF7F00",
            },
            {
              gt: average * 6,
              lte: average * 7,
              label: "红【" + average * 6 + "-" + max + "分】",
              color: "#FF0000",
            },
          ],
          outOfRange: {
            color: "#777",
          },
        },
        series: [
          {
            name: "红",
            type: "gauge",
            radius: "100%",
            startAngle: 180,
            endAngle: 0,
            splitNumber: 0, //刻度数量
            center: ["50%", "65%"],
            axisLine: {
              lineStyle: {
                width: 20,
                shadowBlur: 0,
                color: [[1, "#FF0000 "]],
              },
            },
            axisLabel: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            detail: {
              show: false,
            },
            pointer: {
              show: false,
              length: "100%",
              width: 3,
              title: {
                show: false,
              },
            },
          },

          {
            name: "橙",
            type: "gauge",
            radius: "90%",
            startAngle: 180,
            endAngle: 0,
            splitNumber: 0, //刻度数量
            center: ["50%", "65%"],
            axisLine: {
              lineStyle: {
                width: 20,
                shadowBlur: 0,
                color: [[1, "#FF7F00"]],
              },
            },
            axisLabel: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            detail: {
              show: false,
            },
          },
          {
            name: "黄",
            type: "gauge",
            radius: "80%",
            startAngle: 180,
            endAngle: 0,
            splitNumber: 0, //刻度数量
            center: ["50%", "65%"],
            axisLine: {
              lineStyle: {
                width: 20,
                shadowBlur: 0,
                color: [[1, "#FFFF00"]],
              },
            },
            axisLabel: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            detail: {
              show: false,
            },
          },
          {
            name: "绿",
            type: "gauge",
            radius: "70%",
            startAngle: 180,
            endAngle: 0,
            splitNumber: 0, //刻度数量
            center: ["50%", "65%"],
            axisLine: {
              lineStyle: {
                width: 20,
                shadowBlur: 0,
                color: [[1, "#00FF00"]],
              },
            },
            axisLabel: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            detail: {
              show: false,
            },
          },
          {
            name: "青",
            type: "gauge",
            radius: "60%",
            startAngle: 180,
            endAngle: 0,
            splitNumber: 0, //刻度数量
            center: ["50%", "65%"],
            axisLine: {
              lineStyle: {
                width: 20,
                shadowBlur: 0,
                color: [[1, "#00FFFF"]],
              },
            },
            axisLabel: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            detail: {
              show: false,
            },
          },
          {
            name: "蓝",
            type: "gauge",
            radius: "50%",
            startAngle: 180,
            endAngle: 0,
            splitNumber: 0, //刻度数量
            center: ["50%", "65%"],
            axisLine: {
              lineStyle: {
                width: 20,
                shadowBlur: 0,
                color: [[1, "#0000FF"]],
              },
            },
            axisLabel: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            detail: {
              show: false,
            },
          },
          {
            name: "紫",
            type: "gauge",
            radius: "40%",
            startAngle: 180,
            endAngle: 0,
            splitNumber: 0, //刻度数量
            center: ["50%", "65%"],
            axisLine: {
              lineStyle: {
                width: 20,
                shadowBlur: 0,
                color: [[1, "#8B00FF"]],
              },
            },
            axisLabel: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            detail: {
              show: false,
            },
          },
        ],
      };
      for (let index = 0; index < parseInt(max - score); index++) {
        options.series.shift();
      }
      return options;
    },

    // 获取颜色
    getColorArea(data) {
      var realdata = JSON.parse(data);
      var max = 0,
        min = 0;
      if (realdata && realdata.color) {
        var result = [];
        realdata.color.forEach((m) => {
          if (m.max > max) {
            max = m.max;
          }
          if (m.min < min) {
            min = m.min;
          }
        });
        realdata.color.forEach((m) => {
          var arr = [];
          var value = (m.max / max).toFixed(1);
          arr.push(value);
          arr.push(m.color);
          result.push(arr);
        });

        return result;
      } else {
        return [
          [0.2, "#91c7ae"],
          [0.8, "#63869e"],
          [1, "#c23531"],
        ];
      }
    },
    // 初始化echats
    initChart(options) {
      if (options && document.getElementById(options.id)) {
        this.chart = echarts.init(
          document.getElementById(options.id),
          "westeros"
        );
        this.chart.setOption(options);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.report-warp {
  padding: 30px;
  font-size: 18px;
  line-height: 30px;
  box-sizing: border-box;

  .header {
    .scale-name {
      font-size: 30px;
      color: #6f8483;
      text-align: center;
      font-style: normal;
    }
    .content {
      margin: 20px auto;
      text-align: center;
      .create-time,
      .user-name {
        color: rgb(62, 70, 85);
        font-size: 20px;
      }
    }
  }
  .main {
    .title {
      margin: 10px 0;
      margin-top: 40px;
      font-weight: 600;
      .icon {
        margin-right: -5px;
        font-size: 30px;
        color: rgb(38, 205, 183);
      }
      font-size: 24px;
      color: rgb(24, 98, 88);
    }
    .student-info {
      padding-left: -15px;
      flex-wrap: wrap;
      justify-content: space-between;
      font-size: 20px;
      color: rgb(81, 90, 110);

      div {
        width: 28%;
        line-height: 30px;
        span {
          display: inline-block;
          text-align: right;
          width: 100px;
          font-weight: 600;
        }
      }
      .item {
        width: 44%;
      }
    }
    .introduce {
      .scale {
        margin: 10px 0;
        font-weight: 600;
        font-size: 20px;
      }
    }
    .tab-score {
      width: 100%;
      margin: 0 auto;
      border-top: 1px solid #babfc7;
      border-left: 1px solid #babfc7;
      border-collapse: collapse;
      tr {
        th {
          padding: 5px;
          text-align: center;
          background-color: #f5f7fa;
          border-bottom: 1px solid #babfc7;
          border-right: 1px solid #babfc7;
        }
        td {
          padding: 5px;
          text-align: center;
          border-bottom: 1px solid #babfc7;
          border-right: 1px solid #babfc7;
        }
      }
    }
    .conclusion-warp {
      .conclusion-item {
        margin-bottom: 20px;
        .conclusion-name {
          font-size: 20px;
          font-weight: 600;
          .icon {
            font-size: 24px;
            color: #538cb8;
          }
        }
        .content {
          color: rgb(81, 90, 110);
          .description {
            display: inline-block;
            margin: 10px 0;
            font-size: 16px;
            padding: 2px 20px;
            color: #fff;
            border-radius: 10px;
          }
          div {
            margin-bottom: 10px;
          }
        }
      }
    }
  }
  .bg {
    padding: 15px;
    background: rgb(248, 250, 251);
  }
}
</style>




// WEBPACK FOOTER //
// src/components/detailReport.vue